/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:rectangle-group',
        link : '/dashboard'
    },
    {
        id   : 'calendar',
        title: 'Calendar',
        type : 'basic',
        icon : 'heroicons_outline:calendar',
        link : '/apps/calendar'
    },
    {
        id   : 'clinic.patients',
        title: 'Patients',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/clinic/patients'
    },
    {
        id   : 'clinic.treatment-rooms',
        title: 'Treatment Rooms',
        type : 'basic',
        icon : 'heroicons_outline:building-storefront',
        link : '/clinic/treatment-rooms'
    },
    {
        id   : 'clinic.exercise-library',
        title: 'Exercise Library',
        type : 'basic',
        icon : 'heroicons_outline:play',
        link : '/clinic/exercise-library'
    },
    {
        id   : 'clinic.forms',
        title: 'Forms and Consents',
        type : 'basic',
        icon : 'heroicons_outline:document-text',
        link : '/clinic/forms'
    },
    {
        id   : 'clinic.staff',
        title: 'Staff',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/erp/hr'
    },
    {
        id   : 'clinic.billing',
        title: 'Billing',
        type : 'basic',
        icon : 'heroicons_outline:currency-dollar',
        link : '/clinic/billing'
    },
    {
        id   : 'payment-test',
        title: 'Payment Test',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/payment-test'
    },
    {
        id   : 'settings',
        title: 'Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : '/settings'
    }
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboard',
        title   : 'Dashboard',
        tooltip : 'Dashboard',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        tooltip : 'Apps',
        type    : 'aside',
        icon    : 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        tooltip : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'DASHBOARDS',
        type    : 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'APPS',
        type    : 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id   : 'others',
        title: 'OTHERS',
        type : 'group',
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        type    : 'group',
        icon    : 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'group',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
